export default {"src":"/_next/static/media/sun_filled.990ab315.svg","height":24,"width":24};